import { toDate } from "./dateUtils";

// Både Programmes.CostCenter och FortKnoxPrograms.FortNoxCostCenter är NOT NULL, så en
// jämförelse räcker — saknas cost center blir det ingen träff.
const findProgramLicenseForCostCenter = (school, costCenter) =>
  school?.programLicenses?.find(
    (p) => p.fortNoxProgram.fortNoxCostCenter === costCenter,
  ) ?? null;

export const findLicenseStatus = (licenseStatuses, studentId) =>
  licenseStatuses?.find((l) => l.studentId === studentId) ?? null;

export const canBuyAplLicense = (licenseStatus) =>
  !(
    licenseStatus?.aplLicenseValidTo &&
    toDate(licenseStatus.aplLicenseValidTo) >= new Date()
  );

export const hasProgramLicense = (licenseStatus, programLicenseId) =>
  programLicenseId != null &&
  (licenseStatus?.programLicenseIds ?? []).includes(programLicenseId);

export const findProgramLicenseIdForCostCenter = (school, costCenter) =>
  findProgramLicenseForCostCenter(school, costCenter)?.id ?? null;

export const canBuyForStudent = (licenseStatus, programLicenseId) =>
  canBuyAplLicense(licenseStatus) ||
  !hasProgramLicense(licenseStatus, programLicenseId);

// Licenserna heter "programlicens" i FortNox men visas som "elevlicens" för användaren.
// Delad av adminvyerna och lärarens ClassAdministration så regeln bara finns på ett ställe.
export const toStudentLicenseName = (name) =>
  name?.includes("programlicens")
    ? name.replace("programlicens", "elevlicens")
    : name;

// Grön markerar LWC-licensen som hör till elevens klass, så en elev med flera licenser
// visar vilken som är den relevanta. APL-licensen får egen färg och visas bara när den
// är giltig; den bär en i18n-nyckel (labelId) i stället för ett namn, eftersom LWC-namnen
// kommer från servern medan APL-etiketten är vår egen.
export const programLicensesFor = (
  school,
  licenseStatus,
  currentProgramLicenseId,
) => {
  const licenseIds = licenseStatus?.programLicenseIds ?? [];

  // p.name är serverns DisplayName, alltså LicenseName ?? ProgramName — en fallback på
  // samma två fält vore därför aldrig annat än samma värde.
  const licenses = (school?.programLicenses ?? [])
    .filter((p) => licenseIds.includes(p.id))
    .map((p) => ({
      name: toStudentLicenseName(p.name),
      color:
        currentProgramLicenseId != null && p.id === currentProgramLicenseId
          ? "success"
          : "secondary",
    }))
    .filter((license) => license.name);

  if (licenseStatus?.hasValidAplLicense) {
    licenses.push({ labelId: "AplLicense", color: "info" });
  }

  return licenses;
};

// Shaped like the teacher information the shop normally loads, so ProductsList and
// OrderForm can consume it without knowing which role placed the order.
export const buildAdminOrderContext = (school, user, costCenter, returnTo) => ({
  name: user?.name ?? user?.email ?? "",
  email: user?.email ?? "",
  customer: school,
  programmes: school?.programmes ?? [],
  contact:
    findProgramLicenseForCostCenter(school, costCenter)?.fortNoxReference ?? "",
  returnTo,
});
